import { useRestrictionsForm } from '@/hooks/restrictions/useRestrictionsForm';
import { RestrictionStatus } from '@/models/restriction/status';
import { CreateRestrictionRequestDto } from '@/services/dto/restrictions/create-restriction-input.dto';
import { UpdateRestrictionRequestDto } from '@/services/dto/restrictions/update-restriction-input.dto';
import { ErrorChip, FormGroup, Switch } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';

export default function RestricitonsModalContentStatus() {
  const { t } = useTranslation('common');
  const { setValue, watch } = useFormContext<
    CreateRestrictionRequestDto & UpdateRestrictionRequestDto
  >();
  const {
    useRestrictionByIdQuery: {
      isLoadingRestriction,
      errorRestriction,
      refetchRestriction,
    },
    isCreating,
  } = useRestrictionsForm();

  const status = watch('status');
  const checked = status === RestrictionStatus.Active;

  if (errorRestriction) {
    return <ErrorChip action={refetchRestriction} />;
  }

  if (isCreating) {
    return null;
  }

  return (
    <FormGroup
      label={t('data-grid:status') as string}
      isLoading={isLoadingRestriction}
      loading={{ label: true, secondary: true }}
    >
      <Switch
        isChecked={checked ?? false}
        onChange={() =>
          setValue(
            'status',
            checked ? RestrictionStatus.Inactive : RestrictionStatus.Active,
            {
              shouldDirty: true,
            },
          )
        }
        isLoading={isLoadingRestriction}
      />
    </FormGroup>
  );
}
